module.exports = __webpack_public_path__ + "media/images/deezer-3f88d01405122ab5dcb275b69017f4b6.png";